<!-- 联系我们页面 -->
<template>
  <div class="contact-page">
    <Navbar />

    <!-- 页头 -->
    <section class="contact-hero">
      <div class="contact-hero-overlay"></div>
      <div class="contact-hero-particles">
        <span v-for="n in 8" :key="n" class="particle" :style="{ '--i': n }"></span>
      </div>
      <div class="container">
        <div class="contact-hero-content">
          <span class="section-tag">CONTACT US</span>
          <h1 class="contact-hero-title">联系我们</h1>
          <p class="contact-hero-desc">科曼驰团队为您提供免费凹陷评估及修复方案</p>
          <div class="hero-divider">
            <span class="line"></span>
            <span class="diamond"></span>
            <span class="line"></span>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系方式 -->
    <section class="contact-info-section">
      <div class="container">
        <div class="contact-info-grid">
          <div
            v-for="(item, index) in contactItems"
            :key="index"
            class="contact-info-card"
            :class="item.type"
          >
            <div class="info-icon-wrap">
              <svg v-if="item.type === 'phone'" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="1.5">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
              </svg>
              <svg v-else-if="item.type === 'email'" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="1.5">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
              </svg>
              <svg v-else width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="1.5">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
              </svg>
            </div>
            <div class="info-content">
              <h4>{{ item.title }}</h4>
              <p v-if="item.type === 'phone'" class="info-value"><a :href="'tel:' + item.value">{{ item.value }}</a></p>
              <p v-else-if="item.type === 'email'" class="info-value"><a :href="'mailto:' + item.value">{{ item.value }}</a></p>
              <p v-else class="info-value">{{ item.value }}</p>
              <span v-if="item.sub" class="info-sub">{{ item.sub }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 主内容：地图 + 表单 -->
    <section class="contact-main">
      <div class="container">
        <div class="contact-layout">
          <!-- 左侧：地图 -->
          <div class="contact-map">
            <div class="map-header">
              <span class="section-tag" style="margin-bottom: 8px;">FIND US</span>
              <h3 class="map-title">服务中心位置</h3>
            </div>
            <div class="map-wrapper">
              <iframe
                src="https://map.baidu.com/search/朝阳区金港汽车公园@region=beijing&output=html"
                class="map-frame"
                allowfullscreen
                loading="lazy"
              ></iframe>
              <div class="map-address">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
                <span>朝阳区金港汽车公园A座 · 科曼驰无痕修复中心</span>
              </div>
            </div>
          </div>

          <!-- 右侧：预约表单 -->
          <div class="contact-form-wrap" id="contact-form">
            <div class="form-header">
              <span class="section-tag" style="margin-bottom: 8px;">BOOK NOW</span>
              <h3 class="form-title">免费评估预约</h3>
              <p class="form-desc">填写下方表单，我们将在24小时内与您联系</p>
            </div>
            <form class="booking-form" @submit.prevent="submitForm">
              <div class="form-group">
                <label>您的姓名 <span class="required">*</span></label>
                <input v-model="form.name" type="text" placeholder="请输入姓名" required maxlength="20" />
                <span class="char-count">{{ form.name.length }}/20</span>
              </div>
              <div class="form-group">
                <label>联系电话 <span class="required">*</span></label>
                <input
                  v-model="form.phone"
                  type="tel"
                  placeholder="请输入手机号"
                  maxlength="11"
                  required
                  @input="form.phone = form.phone.replace(/\D/g, '').slice(0, 11)"
                  @blur="form.phone = form.phone.replace(/\D/g, '').slice(0, 11)"
                />
              </div>
              <div class="form-group">
                <label>服务类型 <span class="required">*</span></label>
                <select v-model="form.service" required>
                  <option value="" disabled>请选择服务类型</option>
                  <option :value="1">无痕凹陷修复</option>
                  <option :value="2">挡风玻璃修复</option>
                  <option :value="3">局部点漆</option>
                  <option :value="4">其他咨询</option>
                </select>
              </div>
              <div class="form-group">
                <label>车辆信息</label>
                <input v-model="form.carInfo" type="text" placeholder="车型、年份（如：奔驰C级 2026款）" maxlength="50" />
              </div>
              <div class="form-group">
                <label>问题描述</label>
                <textarea v-model="form.message" rows="3" placeholder="请描述您的车辆损伤情况（凹陷位置、大小等）" maxlength="300"></textarea>
                <span class="char-count">{{ form.message.length }}/300</span>
              </div>
              <!-- 反垃圾：隐藏字段，机器人会填充，正常用户看不到 -->
              <div class="form-group form-honeypot" aria-hidden="true">
                <input v-model="form.honeypot" tabindex="-1" autocomplete="off" />
              </div>
              <!-- 验证码 -->
              <div class="form-group form-captcha">
                <label>验证码 <span class="required">*</span></label>
                <input v-model.number="form.captcha" type="number" placeholder="请输入计算结果" required />
                <button class="captcha-btn" @click="refreshCaptcha" :disabled="countdown > 0">
                  {{ captchaQuestion || '加载中…' }}
                </button>
              </div>
              <button type="submit" class="btn-submit" :disabled="submitting || countdown > 0">
                <span v-if="submitting">提交中…</span>
                <span v-else-if="countdown > 0">{{ countdown }} 秒后可重试</span>
                <span v-else>提交预约</span>
              </button>
              <p v-if="formMsg" :class="['form-msg', formSuccess ? 'success' : 'error']">{{ formMsg }}</p>
            </form>
          </div>
        </div>
      </div>
    </section>

    <!-- 服务时间 -->
    <section class="hours-section">
      <div class="container">
        <div class="section-header">
          <span class="section-tag">WORKING HOURS</span>
          <h2 class="section-title">服务时间</h2>
        </div>
        <div class="hours-grid">
          <div
            v-for="(item, index) in hoursData"
            :key="index"
            class="hours-card"
            :class="{ 'is-today': item.isToday }"
          >
            <div class="hours-day">{{ item.day }}</div>
            <div class="hours-time">{{ item.time }}</div>
            <div class="hours-status" :class="item.statusClass">{{ item.statusText }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- 常见问题 -->
    <section class="faq-section">
      <div class="container">
        <div class="section-header">
          <span class="section-tag">FAQ</span>
          <h2 class="section-title">常见问题</h2>
          <p class="section-subtitle">解答您关心的问题</p>
        </div>
        <div class="faq-list">
          <div
            v-for="(item, index) in faqData"
            :key="index"
            class="faq-item"
            :class="{ open: openFaq === index }"
            @click="openFaq = openFaq === index ? -1 : index"
          >
            <div class="faq-question">
              <span class="faq-q-num">{{ String(index + 1).padStart(2, '0') }}</span>
              <h4>{{ item.q }}</h4>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </div>
            <div class="faq-answer">
              <p>{{ item.a }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <el-backtop :visibility-height="200" />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import Navbar from '@/components/Navbar.vue'

// 联系方式数据
const contactItems = ref([
  {
    type: 'phone',
    title: '服务热线',
    value: '159-3133-4385',
    sub: '周一至周日 9:00 - 18:30',
  },
  {
    type: 'email',
    title: '电子邮箱',
    value: 'komanchpdr@gmail.com',
    sub: '24小时内回复',
  },
  {
    type: 'address',
    title: '服务中心',
    value: '朝阳区金港汽车公园A座',
    sub: '科曼驰无痕修复中心',
  },
])

// 营业时间数据
const hoursData = ref([
  { day: '周一', time: '9:00 - 18:30' },
  { day: '周二', time: '9:00 - 18:30' },
  { day: '周三', time: '9:00 - 18:30' },
  { day: '周四', time: '9:00 - 18:30' },
  { day: '周五', time: '9:00 - 18:30' },
  { day: '周六', time: '9:00 - 18:30' },
  { day: '周日', time: '9:00 - 18:30' },
])

// 营业时间配置
const OPEN_HOUR = 9
const CLOSE_HOUR = 18
const CLOSE_MINUTE = 30

// 计算某天当前是否营业中
const getDayStatus = (date) => {
  const h = date.getHours()
  const m = date.getMinutes()
  const nowMinutes = h * 60 + m
  const openMinutes = OPEN_HOUR * 60
  const closeMinutes = CLOSE_HOUR * 60 + CLOSE_MINUTE
  return nowMinutes >= openMinutes && nowMinutes < closeMinutes
}

// 实时更新时间状态
const updateHoursStatus = () => {
  const now = new Date()
  const todayIndex = now.getDay() === 0 ? 6 : now.getDay() - 1
  const isOpen = getDayStatus(now)

  hoursData.value = hoursData.value.map((item, i) => ({
    ...item,
    isToday: i === todayIndex,
    statusText: isOpen ? '营业中' : '休息中',
    statusClass: isOpen ? 'open' : 'close',
  }))
}

updateHoursStatus()
// 每分钟刷新一次
setInterval(updateHoursStatus, 60000)

// 常见问题
const faqData = ref([
  { q: '无痕凹陷修复会不会伤到原厂漆？', a: '不会。我们的PDR技术是从车身内部进行顶推修复，完全不接触漆面外侧，保留原厂漆完整无损，车辆保值不受影响。' },
  { q: '修复需要多长时间？', a: '大多数凹陷修复在30分钟到1小时内即可完成。挡风玻璃修复约需15-30分钟。具体时长视损伤程度而定。' },
  { q: '上门修复覆盖哪些区域？', a: '目前覆盖北京全域，包括朝阳、海淀、丰台、东城、西城、通州、大兴等区域。偏远地区需提前确认。' },
  { q: '质保期是多久？', a: '所有修复项目均提供两年质保。质保期内如出现修复效果回弹等问题，可免费返修。' },
  { q: '费用如何计算？', a: '费用根据凹陷大小、位置、数量综合评估。我们提供免费上门评估服务，确认方案后报价，无隐形消费。' },
])

const openFaq = ref(-1)

// 表单数据
const form = ref({ name: '', phone: '', service: '', carInfo: '', message: '', honeypot: '', captcha: null })
const submitting = ref(false)
const formMsg = ref('')
const formSuccess = ref(false)
const captchaQuestion = ref('')
const captchaAnswer = ref(0)
const countdown = ref(0)

let countdownTimer = null

// 生成验证码
const generateCaptcha = () => {
  const ops = ['+', '-']
  const op = ops[Math.floor(Math.random() * ops.length)]
  let a, b, answer
  if (op === '+') {
    a = Math.floor(Math.random() * 20) + 1
    b = Math.floor(Math.random() * 20) + 1
    answer = a + b
  } else {
    a = Math.floor(Math.random() * 20) + 5
    b = Math.floor(Math.random() * a)
    answer = a - b
  }
  captchaQuestion.value = `${a} ${op} ${b} = ?`
  captchaAnswer.value = answer
}

const refreshCaptcha = () => {
  generateCaptcha()
}

const startCountdown = () => {
  countdown.value = 60
  countdownTimer = setInterval(() => {
    countdown.value--
    if (countdown.value <= 0) {
      clearInterval(countdownTimer)
      countdownTimer = null
    }
  }, 1000)
}

const submitForm = async () => {
  formMsg.value = ''
  formSuccess.value = false

  if (!form.value.name || !form.value.phone || !form.value.service) {
    formMsg.value = '请填写必要信息'
    formSuccess.value = false
    return
  }
  if (form.value.name.length > 20) {
    formMsg.value = '姓名不能超过20个字'
    formSuccess.value = false
    return
  }
  if (!/^1[3-9]\d{9}$/.test(form.value.phone)) {
    formMsg.value = '请输入正确的手机号码'
    formSuccess.value = false
    return
  }
  if (form.value.message.length > 300) {
    formMsg.value = '问题描述不能超过300个字'
    formSuccess.value = false
    return
  }
  if (form.value.honeypot && form.value.honeypot !== '') {
    return
  }
  if (form.value.captcha === undefined || form.value.captcha === null) {
    formMsg.value = '请输入验证码'
    formSuccess.value = false
    return
  }
  if (form.value.captcha !== captchaAnswer.value) {
    formMsg.value = '验证码错误，请重试'
    formSuccess.value = false
    refreshCaptcha()
    return
  }

  submitting.value = true
  try {
    const submitPayload = {
      name: form.value.name,
      phone: form.value.phone,
      service: form.value.service,
      carDesc: [form.value.carInfo, form.value.message].filter(Boolean).join(' | '),
      _ts: Date.now(),
      captcha: form.value.captcha,
    }
    const res = await axios.post('/webapi/apply/submit', submitPayload)
    if (res.data.ActionType === 'OK') {
      formMsg.value = '提交成功！我们将在24小时内与您联系。'
      formSuccess.value = true
      form.value = { name: '', phone: '', service: '', carInfo: '', message: '', honeypot: '', captcha: null }
      startCountdown()
      refreshCaptcha()
    } else {
      formMsg.value = res.data.error || '提交失败，请稍后重试'
      formSuccess.value = false
      refreshCaptcha()
    }
  } catch (e) {
    formMsg.value = '网络错误，请稍后重试'
    formSuccess.value = false
    refreshCaptcha()
  } finally {
    submitting.value = false
  }
}

onMounted(() => {
  generateCaptcha()
})
</script>

<style scoped lang="scss">
// ===== 变量 =====
$gold: #d4af37;
$dark: #1a1a1a;
$gray: #6b7280;
$light-gray: #f8f9fa;
$border: #e5e7eb;

// ===== 全局 =====
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.section-tag {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 4px;
  text-transform: uppercase;
  color: $gold;
  display: block;
  margin-bottom: 12px;
}

.section-title {
  font-size: 36px;
  font-weight: 800;
  color: $dark;
  margin: 8px 0 12px;
}

.section-subtitle {
  font-size: 16px;
  color: $gray;
}

.section-header {
  text-align: center;
  margin-bottom: 56px;
}

.hero-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin: 28px 0;

  .line {
    width: 80px;
    height: 1px;
    background: linear-gradient(to right, transparent, $gold, transparent);
    opacity: 0.5;
  }

  .diamond {
    width: 6px;
    height: 6px;
    background: $gold;
    transform: rotate(45deg);
  }
}

// ===== 页头 =====
.contact-hero {
  position: relative;
  min-height: 520px;
  background: linear-gradient(135deg, $dark 0%, #2a2a2a 100%);
  display: flex;
  align-items: center;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -20%;
    right: -5%;
    width: 600px;
    height: 600px;
    background: radial-gradient(circle, rgba(212,175,55,0.08) 0%, transparent 70%);
    border-radius: 50%;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, $gold, transparent);
    opacity: 0.3;
  }
}

.contact-hero-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.2) 100%);
}

.contact-hero-particles {
  position: absolute;
  inset: 0;
  pointer-events: none;

  .particle {
    position: absolute;
    width: 4px;
    height: 4px;
    background: $gold;
    border-radius: 50%;
    opacity: 0;
    box-shadow: 0 0 8px $gold;
    animation: floatParticle 4s ease-in-out infinite;
    animation-delay: calc(var(--i) * 0.4s);
  }
}

@keyframes floatParticle {
  0%, 100% { transform: translateY(0) scale(1); opacity: 0.2; }
  50% { transform: translateY(-40px) scale(1.3); opacity: 0.6; }
}

.contact-hero-content {
  position: relative;
  z-index: 2;
  padding: 60px 0;
  text-align: center;

  .contact-hero-title {
    font-size: 52px;
    font-weight: 800;
    color: #fff;
    letter-spacing: 2px;
    margin-bottom: 16px;
  }

  .contact-hero-desc {
    font-size: 17px;
    color: rgba(255,255,255,0.6);
    letter-spacing: 1px;
  }
}

// ===== 联系方式卡片 =====
.contact-info-section {
  padding: 60px 0;
  background: #fff;
}

.contact-info-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.contact-info-card {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  padding: 28px;
  background: $light-gray;
  border-radius: 16px;
  border: 1px solid $border;
  transition: all 0.4s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 32px rgba(0,0,0,0.08);
    border-color: rgba(212,175,55,0.3);
  }

  &.phone {
    .info-icon-wrap { background: rgba(212,175,55,0.1); }
  }

  &.email {
    .info-icon-wrap { background: rgba(59,130,246,0.1); }
  }

  &.address {
    .info-icon-wrap { background: rgba(16,185,129,0.1); }
  }

  .info-icon-wrap {
    width: 56px;
    height: 56px;
    flex-shrink: 0;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .info-content {
    h4 {
      font-size: 16px;
      font-weight: 700;
      color: $dark;
      margin-bottom: 6px;
    }

    .info-value {
      font-size: 15px;
      color: $gray;
      margin-bottom: 4px;

      a {
        color: inherit;
        text-decoration: none;
        transition: color 0.3s ease;

        &:hover { color: $gold; }
      }
    }

    .info-sub {
      font-size: 13px;
      color: #bbb;
    }
  }
}

// ===== 主内容区 =====
.contact-main {
  padding: 60px 0 80px;
  background: $light-gray;
}

.contact-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: start;
}

// 地图
.contact-map {
  .map-header {
    margin-bottom: 20px;

    .map-title {
      font-size: 22px;
      font-weight: 700;
      color: $dark;
    }
  }

  .map-wrapper {
    border-radius: 16px;
    overflow: hidden;
    border: 1px solid $border;
    background: #fff;

    .map-frame {
      width: 100%;
      height: 360px;
      border: none;
      display: block;
    }

    .map-address {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 14px 20px;
      background: $light-gray;
      font-size: 14px;
      color: $gray;
    }
  }
}

// 表单
.contact-form-wrap {
  background: #fff;
  border-radius: 16px;
  padding: 36px;
  border: 1px solid $border;
  box-shadow: 0 4px 16px rgba(0,0,0,0.04);

  .form-header {
    margin-bottom: 28px;

    .form-title {
      font-size: 22px;
      font-weight: 700;
      color: $dark;
      margin-bottom: 6px;
    }

    .form-desc {
      font-size: 14px;
      color: $gray;
    }
  }
}

// ===== 营业时间 =====
.hours-section {
  padding: 80px 0;
  background: #fff;
}

.hours-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 12px;
}

.hours-card {
  text-align: center;
  padding: 20px 12px;
  background: $light-gray;
  border-radius: 12px;
  border: 1px solid $border;
  transition: all 0.3s ease;

  &.is-today {
    background: rgba(212,175,55,0.08);
    border-color: $gold;
    box-shadow: 0 4px 12px rgba(212,175,55,0.15);
  }

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 20px rgba(0,0,0,0.08);
  }

  .hours-day {
    font-size: 14px;
    font-weight: 600;
    color: $dark;
    margin-bottom: 8px;
  }

  .hours-time {
    font-size: 13px;
    color: $gray;
    margin-bottom: 10px;
  }

  .hours-status {
    font-size: 12px;
    font-weight: 600;
    padding: 3px 10px;
    border-radius: 20px;
    display: inline-block;

    &.open {
      background: rgba(82,196,26,0.1);
      color: #52c41a;
    }

    &.close {
      background: rgba(128,128,128,0.08);
      color: #999;
    }
  }
}

// ===== 常见问题 =====
.faq-section {
  padding: 80px 0;
  background: $light-gray;
}

.faq-list {
  max-width: 800px;
  margin: 0 auto;
}

.faq-item {
  background: #fff;
  border: 1px solid $border;
  border-radius: 12px;
  margin-bottom: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    border-color: rgba(212,175,55,0.3);
  }

  &.open {
    border-color: $gold;
    box-shadow: 0 4px 16px rgba(212,175,55,0.1);
  }

  .faq-question {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 18px 24px;

    .faq-q-num {
      font-size: 14px;
      font-weight: 700;
      color: $gold;
      flex-shrink: 0;
      width: 28px;
    }

    h4 {
      flex: 1;
      font-size: 15px;
      font-weight: 600;
      color: $dark;
    }

    .faq-arrow {
      flex-shrink: 0;
      transition: transform 0.3s ease;
      color: $gray;
    }
  }

  &.open .faq-arrow {
    transform: rotate(180deg);
    color: $gold;
  }

  .faq-answer {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.4s ease;

    &.open {
      max-height: 200px;
    }
  }

  &.open .faq-answer {
    max-height: 200px;
  }

  .faq-answer p {
    padding: 0 24px 18px 68px;
    font-size: 14px;
    color: $gray;
    line-height: 1.8;
  }
}

// ===== 响应式 =====
@media (max-width: 1024px) {
  .contact-layout { grid-template-columns: 1fr; }
  .contact-hero-content .contact-hero-title { font-size: 40px; }
  .hours-grid { grid-template-columns: repeat(4, 1fr); }
}

@media (max-width: 768px) {
  .contact-hero-content .contact-hero-title { font-size: 32px; }
  .contact-hero { min-height: 340px; margin-top: 72px; }
  .contact-hero-content { padding: 40px 0; }
  .contact-info-grid { grid-template-columns: 1fr; }
  .hours-grid { grid-template-columns: repeat(3, 1fr); }
  .faq-question { padding: 14px 16px; }
  .faq-answer p { padding: 0 16px 14px; }
}

</style>

<style lang="scss">
// 非 scoped：booking-form 表单样式，与首页一致
.booking-form {
  width: 100%;

  .form-group {
    width: 100%;
    margin-bottom: 16px;

    label {
      display: block;
      font-size: 14px;
      font-weight: 600;
      color: #1a1a1a;
      margin-bottom: 6px;
    }

    input, select, textarea {
      width: 100% !important;
      max-width: 100% !important;
      display: block;
      box-sizing: border-box;
      padding: 12px 16px;
      font-size: 15px;
      border: 1px solid #e5e7eb;
      border-radius: 10px;
      background: #fff;
      color: #1a1a1a;
      font-family: inherit;
      appearance: none;
      -webkit-appearance: none;

      &::placeholder { color: #bbb; }

      &:focus {
        outline: none;
        border-color: #d4af37;
        box-shadow: 0 0 0 3px rgba(212, 175, 55, 0.1);
      }
    }

    select {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: right 14px center;
      padding-right: 36px;
      cursor: pointer;
    }

    textarea {
      resize: vertical;
    }

    .char-count {
      display: block;
      font-size: 12px;
      color: #bbb;
      text-align: right;
      margin-top: 4px;
    }
  }

  .form-honeypot { display: none !important; }

  .form-captcha {
    label { margin-bottom: 6px; }

    .captcha-btn {
      width: 100%;
      padding: 12px 16px;
      font-size: 14px;
      font-weight: 600;
      color: #fff;
      background: #1a1a1a;
      border: none;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.3s ease;
      margin-top: 6px;

      &:hover:not(:disabled) { background: #333; }
      &:disabled { opacity: 0.5; cursor: not-allowed; }
    }
  }

  .btn-submit {
    width: 100%;
    padding: 14px;
    font-size: 15px;
    font-weight: 600;
    color: #fff;
    background: #d4af37;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover:not(:disabled) {
      background: #c4a030;
      transform: translateY(-1px);
      box-shadow: 0 8px 24px rgba(212, 175, 55, 0.3);
    }
    &:disabled { opacity: 0.6; cursor: not-allowed; }
  }

  .form-msg {
    margin-top: 12px;
    font-size: 13px;
    text-align: center;

    &.success { color: #52c41a; }
    &.error { color: #ff4d4f; }
  }
}
</style>
